const AnalysisStudyLogPerformanceConstants = {
  LOAD_START: "analysisStudyLogPerformance/LOAD_START",
  LOAD_START_V2_STUDY_LIST: "analysisStudyLogPerformance/LOAD_START_V2_STUDY_LIST",
  LOAD_START_V2_STUDY: "analysisStudyLogPerformance/LOAD_START_V2_STUDY",
  LOAD_START_V2_STUDY_TASK: "analysisStudyLogPerformance/LOAD_START_V2_STUDY_TASK",
  MAIN_FUNCTIONALITY: "analysisStudyLogPerformance/MAIN_FUNCTIONALITY",
  STEP_METADATA_MAIN_FUNCTIONALITY: "analysisStudyLogPerformance/STEP_METADATA_MAIN_FUNCTIONALITY",
  FORAY_METADATA_MAIN_FUNCTIONALITY: "analysisStudyLogPerformance/FORAY_METADATA_MAIN_FUNCTIONALITY",
  STUDY_ABSTRACTS_V2_MAIN_FUNCTIONALITY: "analysisStudyLogPerformance/STUDY_ABSTRACTS_V2_MAIN_FUNCTIONALITY",
  STUDY_ABSTRACT_V2_MAIN_FUNCTIONALITY: "analysisStudyLogPerformance/STUDY_ABSTRACT_V2_MAIN_FUNCTIONALITY",
  STUDY_TASK_V2_MAIN_FUNCTIONALITY: "analysisStudyLogPerformance/STUDY_TASK_V2_MAIN_FUNCTIONALITY",
  MAIN_FUNCTIONALITY_V2_STUDY_LIST: "analysisStudyLogPerformance/MAIN_FUNCTIONALITY_V2_STUDY_LIST",
  MAIN_FUNCTIONALITY_V2_STUDY: "analysisStudyLogPerformance/MAIN_FUNCTIONALITY_V2_STUDY",
  MAIN_FUNCTIONALITY_V2_STUDY_TASK: "analysisStudyLogPerformance/MAIN_FUNCTIONALITY_V2_STUDY_TASK"
};
export {
  AnalysisStudyLogPerformanceConstants as default
};
//# sourceMappingURL=AnalysisStudyLogPerformanceConstants.js.map
